export interface GeometryResponse {
  geometry: string;
}
